// extracted by mini-css-extract-plugin
export default {"container":"buySellLabel_container__49vme","buy":"buySellLabel_buy__S0KXp","sell":"buySellLabel_sell__0y6Jz"};